<template>

    <div>
        <Row :gutter="16">
            <Col span="24">
                <Card>
                    <p slot="title">{{t.routerName}}</p>
                    <Row>
                        <Col>
                            <Form :model="formItem" :rules="ruleValidate" :label-width="85" label-position="right"
                                  ref="form">
                                <FormItem :label="t.tag.name" prop="name">
                                    <Input v-model="formItem.name" :maxlength="20"
                                           :placeholder="msgUtil.placeholderRequired(t.tag.name)"></Input>
                                </FormItem>
                                <FormItem :label="t.tag.sortOrder" prop="sortOrder">
                                    <InputNumber v-model="formItem.sortOrder" :max="9999" :min="0"></InputNumber>
                                </FormItem>
                                <FormItem :label="t.tag.status" prop="status">
                                    <i-switch v-model="formItem.status" size="large" true-value="1" false-value="0">
                                        <span slot="open">{{t.tag.open}}</span>
                                        <span slot="close">{{t.tag.close}}</span>
                                    </i-switch>
                                </FormItem>
                                <FormItem>
                                    <Button type="primary" :loading="loading" @click="handleSubmit()">
                                        {{msgUtil.message.action.submit}}
                                    </Button>
                                    <Button @click="handleReset()" style="margin-left: 8px">
                                        {{msgUtil.message.action.reset}}
                                    </Button>
                                </FormItem>
                            </Form>
                        </Col>
                    </Row>
                </Card>
            </Col>
        </Row>
    </div>
</template>

<script>
    import {edit, getTagInfo} from '@/api/tag';

    export default {
        name: 'content_tag_edit',
        data() {
            const t = this.$_t();
            const msgUtil = this.$msgUtil;
            return {
                self: this,
                t: t,
                msgUtil: msgUtil,
                formItemBk: {},
                formItem: {
                    name: '',
                    status: '1',
                    sortOrder: 0,
                },
                ruleValidate: {
                    name: [
                        {
                            required: true,
                            message: msgUtil.errorRequired(t.tag.name),
                            trigger: 'blur',
                        },
                        {
                            type: 'string',
                            max: 20,
                            message: msgUtil.errorMaxLengthFullWidth(t.tag.name, 20),
                            trigger: 'blur',
                        },
                    ],
                    sortOrder: [
                        {
                            required: true,
                            type: 'number',
                            message: msgUtil.errorRequired(t.tag.sortOrder),
                            trigger: 'blur',
                        },
                    ],
                },
                loading: false,
            };
        },
        methods: {
            handleSubmit() {
                this.loading = true;
                this.$Loading.start();
                this.$refs['form'].validate(async valid => {
                    if (valid) {
                        this.loading = true;
                        let tagDto = {};
                        tagDto.name = this.formItem.name;
                        tagDto.status = this.formItem.status;
                        tagDto.sortOrder = this.formItem.sortOrder;
                        await edit(this.$route.params.id, tagDto);
                        Object.assign(this.formItemBk, this.formItem);
                        this.$Message.success(this.msgUtil.message.action.updateSuccess);
                        this.$Loading.finish();
                    } else {
                        this.$Loading.error();
                        this.$Message.error(this.msgUtil.message.action.updateFail);
                    }
                });
                this.loading = false;
            },

            handleReset() {
                Object.assign(this.formItem, this.formItemBk);
                this.loading = false;
            },
            async init() {
                const tagInfo = await getTagInfo(this.$route.params.id);
                if (tagInfo.tag != null) {
                    this.formItem = tagInfo.tag;
                    Object.assign(this.formItemBk, tagInfo.tag);
                }
            },
        },
        async mounted() {
            await this.init();
        },
    };
</script>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
